import {apiLink, apiV2Link, Scenario} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {IOfferDetailApplication} from "../../offer/types/IOfferDetailApplication";
import {IPropertyDetailApplication} from "../../property/types/IPropertyDetailApplication";
import {IVendorDetailApplication} from "../../vendor/types/IVendorDetailApplication";
import {IApplicationData} from "../types/IApplicationData";

interface IPatchApplicationParams {
    uuid: string;
    body: Partial<IApplicationData & {consumer_segment: number}>;
}

export const applicationLeadDataApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        getApplicationVendorDetail: build.query<IVendorDetailApplication, {vendorId: number}>({
            query: ({vendorId}) => ({
                url: apiV2Link.vendor.detail(Scenario.VENDOR_DETAIL_APPLICATION, {vendorId})
            })
        }),
        getApplicationOfferDetail: build.query<IOfferDetailApplication, {offerId: number}>({
            query: ({offerId}) => ({
                url: apiV2Link.offer.detail(Scenario.OFFER_APPLICATION, {offerId})
            })
        }),
        getApplicationPropertyDetail: build.query<IPropertyDetailApplication, {propertyId: number}>({
            query: ({propertyId}) => ({
                url: apiV2Link.property.detail(Scenario.PROPERTY_APPLICATION, {propertyId})
            })
        }),
        patchApplication: build.mutation<IApplicationData, IPatchApplicationParams>({
            query: ({uuid, body}) => ({
                url: apiLink.application.detail({})({uuid}),
                method: "PATCH",
                body
            })
        }),
        getClipPhoneByPropertyId: build.query<{clip_number: string}, {propertyId: number}>({
            query: ({propertyId}) => ({
                url: apiLink.clipPhones.property({})({propertyId})
            })
        })
    })
});

export const {
    useGetApplicationVendorDetailQuery,
    useGetApplicationOfferDetailQuery,
    useGetApplicationPropertyDetailQuery,
    usePatchApplicationMutation,
    useLazyGetClipPhoneByPropertyIdQuery
} = applicationLeadDataApi;
